import { useState, useEffect } from 'react';
import { useTheme } from '../../context/ThemeContext';
import { leadService, masterService } from '../../services/api';
import { Select, Input, Button, Toast } from '../../components/ui';

const CallFeedbackForm = ({ lead, onClose, onUpdated }) => {
  const { dark } = useTheme();
  const [feedbacks, setFeedbacks] = useState([]);
  const [form, setForm] = useState({ feedbackId: '', callDuration: '', remarks: '', nextFollowUpDate: '', nextFollowUpTime: '' });
  const [loading, setLoading] = useState(false);
  const [toast, setToast] = useState(null);

  useEffect(() => {
    masterService.getCallFeedbacks()
      .then(({ data }) => setFeedbacks(data.data || []))
      .catch(console.error);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.feedbackId || !form.callDuration) {
      setToast({ msg: 'Please select feedback and duration', type: 'error' });
      return;
    }
    const selectedFB = feedbacks.find(f => f._id === form.feedbackId);
    if (!selectedFB) return;
    setLoading(true);
    try {
      await leadService.recordCall(lead._id, {
        feedbackId: form.feedbackId,
        feedbackCode: selectedFB.code,
        callDuration: parseInt(form.callDuration) * 60,
        remarks: form.remarks,
        nextFollowUpDate: form.nextFollowUpDate || undefined,
        nextFollowUpTime: form.nextFollowUpTime || undefined,
      });
      setToast({ msg: 'Call feedback saved successfully', type: 'success' });
      if (onUpdated) onUpdated();
      setTimeout(onClose, 1500);
    } catch (err) {
      setToast({ msg: err.response?.data?.message || err.message || 'Error saving feedback', type: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      {toast && <Toast message={toast.msg} type={toast.type} onClose={() => setToast(null)} />}
      <form onSubmit={handleSubmit}>
        <p style={{ fontSize: 13, color: dark ? '#94A3B8' : '#64748B', margin: '0 0 16px' }}>
          Recording call for <strong>{lead?.fullName}</strong> ({lead?.leadId})
        </p>
        <Select label="Call Feedback *" value={form.feedbackId} onChange={e => setForm({ ...form, feedbackId: e.target.value })} options={feedbacks.map(f => ({ value: f._id, label: f.name }))} />
        <Input label="Call Duration (minutes) *" type="number" value={form.callDuration} onChange={e => setForm({ ...form, callDuration: e.target.value })} placeholder="e.g. 5" />
        <Input label="Remarks" value={form.remarks} onChange={e => setForm({ ...form, remarks: e.target.value })} placeholder="Enter call notes..." />
        <Input label="Next Follow-up Date" type="date" value={form.nextFollowUpDate} onChange={e => setForm({ ...form, nextFollowUpDate: e.target.value })} />
        <Input label="Next Follow-up Time" type="time" value={form.nextFollowUpTime} onChange={e => setForm({ ...form, nextFollowUpTime: e.target.value })} />
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
          <Button variant="outline" type="button" onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={loading}>Save Feedback</Button>
        </div>
      </form>
    </div>
  );
};

export default CallFeedbackForm;
